import { FormBase } from 'core/components';

export default class EmailTemplatesEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'body',
                    label: 'EMAIL_TEMPLATES.EDIT.TITLE',
                    placeholder: 'EMAIL_TEMPLATES.TITLE',
                    rules: ['string', 'required'],
                },
            ],
        };
    }
}
